// ============================================================================
// src/broiler/broilerRoutes.ts — the broiler domain's route table.
// ============================================================================
// B3.1 finish, fourth domain. Same shape as the cattle, sheep and layer
// tables.
//
// Note what is NOT here: 'broilerweighins' (/broiler/weighins) is still a
// clause in App(), because it mounts the shared LivestockWeighInsView with a
// species prop rather than a broiler-owned view. It joins a table when the
// remaining App() clauses are converted, not before -- moving it now would
// mean this domain's entry importing a livestock/ component, which is the
// coupling the per-domain split exists to avoid.
//
//   /broiler/dailys/<id>   BroilerDailysView — daily record page
//   /broiler/batches/<id>  BroilerListRouter — batch record page
//
// '/broiler', '/broiler/timeline' and '/broiler/feed' are exact.
// ============================================================================

export const BROILER_ROUTES = [
  {view: 'broilerHome', paths: ['/broiler']},
  {view: 'timeline', paths: ['/broiler/timeline']},
  {view: 'broilerdailys', paths: ['/broiler/dailys/*']},
  {view: 'list', paths: ['/broiler/batches/*']},
  {view: 'feed', paths: ['/broiler/feed']},
];
